import { createClient } from 'contentful'

// establishing a Contentful client connection
export const client = createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_KEY,
    environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT === 'prd' ? 'new' : process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT // TODO clean this after mobile apps have been updated
})
